var _path, _circle, _circle2, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackSidebarButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60059 4.90039V6.30039",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5006,
    cy: 11.1998,
    r: 1.4,
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.50059,
    cy: 11.1998,
    r: 1.4,
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1 11.1811C2.33229 11.1428 1.85337 11.0286 1.51256 10.6878C1 10.1753 1 9.35031 1 7.70039V4.90039C1 3.25047 1 2.42552 1.51256 1.91295C2.02513 1.40039 2.85008 1.40039 4.5 1.40039H6.81C7.59174 1.40039 7.98261 1.40039 8.29894 1.50317C8.93825 1.7109 9.43949 2.21214 9.64722 2.85145C9.75 3.16778 9.75 3.55865 9.75 4.34039C9.75 4.86155 9.75 5.12213 9.81852 5.33301C9.95701 5.75923 10.2912 6.09338 10.7174 6.23187C10.9283 6.30039 11.1888 6.30039 11.71 6.30039H15V7.70039C15 9.35031 15 10.1753 14.4874 10.6878C14.1466 11.0286 13.6677 11.1428 12.9 11.1811M5.9 11.2004H10.1",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.7998H11.0249C12.0436 2.7998 12.553 2.7998 12.9675 3.0474C13.382 3.295 13.6235 3.74348 14.1065 4.64045L15 6.2998",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7998 4.90039V6.30039",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackSidebarButton);
export default __webpack_public_path__ + "static/media/track-sidebar-button.81676d8ad9f1a3d937cd69aa36eb2439.svg";
export { ForwardRef as ReactComponent };